import { reducerFactory } from 'common/store/scope';
import { composeReducers } from '../util';

import {
  LOAD,
  LOAD_SUCCESS,
  LOAD_ERROR,
  UPDATE,
  CLEAR,
} from './actions';

import {
  defaultState as errorState,
  onError,
  clearError,
} from '../error/reducer';

import {
  defaultState as loadingState,
  startLoading,
  stopLoading,
} from '../loading/reducer';

export const defaultState = {
  ...errorState,
  ...loadingState,
  data: undefined,
};

export const clearData = state => ({
  ...state,
  data: undefined,
});

export const clear = composeReducers(
  clearError,
  clearData,
);

export const update = (state, { resource }) => ({
  ...state,
  data: resource,
});

export const load = (state, action) => composeReducers(...[
  startLoading,
  action.clear && clear,
].filter(Boolean))(state, action);

export const loadSuccess = composeReducers(
  stopLoading,
  clearError,
  update,
);

export const loadError = composeReducers(
  stopLoading,
  clearData,
  onError,
);

export const loadCancelled = stopLoading;

const resourceReducer = (state = defaultState, action) => {
  const reducer = {
    [LOAD]: load,
    [LOAD_SUCCESS]: loadSuccess,
    [LOAD_ERROR]: loadError,
    [UPDATE]: update,
    [CLEAR]: clear,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};

export const factory = namespace => reducerFactory(namespace, resourceReducer);

export default factory;
